import { render } from "./ConfirmMailPage.vue?vue&type=template&id=3283929c&ts=true"
import script from "./ConfirmMailPage.vue?vue&type=script&lang=ts"
export * from "./ConfirmMailPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__